import { Caption } from '@cian/ui-kit';

import { IUndergroundInfo } from '../../../types/promoInventory';
import { SubwayInfoContainer } from '../SubwayInfoContainer';

interface IAddressInfoProps {
  subwayInfo?: IUndergroundInfo | null;
  address: string;
}

export function AddressInfo({ address, subwayInfo }: IAddressInfoProps) {
  if (!subwayInfo) {
    return (
      <Caption display="block" color="text-secondary-default" ellipsis>
        {address}
      </Caption>
    );
  }

  return <SubwayInfoContainer subwayInfo={subwayInfo} />;
}
